// extracted by mini-css-extract-plugin
export default {"horizontalDivider":"HorizontalDivider_horizontalDivider__N1+DK"};